import { Sport } from '../sports/data_types'
import { unitSystemsMap } from './constants'
import { UnitsState, UnitSystem } from './types'

// Get unit system
export function getUnitSystem(units: UnitsState, sport: Sport): UnitSystem {
  // Use default unit system if selected is 'Default' and sport has a default unit system that is available
  // Otherwise use selected unit system if available
  // Otherwise use SI (Always available)
  if (units.selected === 'Default') {
    return (
      unitSystemsMap[sport.props.features.defaultUnitSystem] ||
      unitSystemsMap.SI
    )
  } else {
    return unitSystemsMap[units.selected] || unitSystemsMap.SI
  }
}
